/**
 * 访问会员详情页面
 */
export const MEMBER_DETAIL_PAGE_UUID = 'a288d1cd-f674-4114-b217-2dec1df69a43'

/**
 * 管理会员
 */
export const MEMBER_MANAGE_ACTION_UUID = 'dfa1a114-00e2-4cde-8c6c-487d20e399da'
